<template>
  <el-container id="glArea">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-aside width="240px" class="div_left" style="display:flex;">
        <div style="height:100%;position:relative;overflow: hidden;background:#FFFFFF;">
          <el-header height="60px" style="width:240px;display:flex;align-items:center;background:#FFFFFF;">
            <p style="width:auto;height:auto;font-size:20px;font-weight:bold;margin-left:15px">全部区域</p>
          </el-header>
          <ul class="left_main" style="height:70vh;">
            <li v-for="(g,index) in li_build" :key="g.id" style="height:40px;margin-left:8px;margin-right:8px;"
                @click="btnClick(index)"
                :class="{active:currentIndex === index}">
              <div style="display:flex;width:auto;height:40px;line-height:0.4">
                <p style="width:50%;text-align:left;margin-left:15px;">{{ g.name }}</p>
              </div>
            </li>
          </ul>
          <div class="left_footer">
            <el-divider></el-divider>
            <div @click="addArea" style="height:50px;display:flex;justify-content:center;align-items:center;">
              <i class="el-icon-plus" style="color: #134FC2;"></i>
              <p style="margin-left:10px;margin-right:10px;font-size:15px;color:#134FC2;">新增区域</p>
            </div>
          </div>
        </div>
      </el-aside>
      <el-container style="padding-left:6px;background: #F7F7F7">
        <el-aside height="100%" width="60%" style="background: #FFFFFF">
          <div style="display:flex;height:50px;width:100%;line-height:0.3;text-align:left;align-items: center;">
            <p @click="changBuildName" style="width:auto;font-size:18px;font-weight:bold;margin-left:15px">
              {{ build_name }}
              <i class="el-icon-edit" style="font-size:18px;margin-left:0.5vw"></i>
            </p>
            <el-button v-if="syncYk" @click="upYk" size="small" type="warning"
                       style="margin-left:20px">易控导入
            </el-button>
            <el-button v-if="syncScene" @click="upScene" size="small" type="warning" style="margin-left:0.5vw">
              同步场景
            </el-button>
            <el-button v-if="syncScene" @click="upSceneOpen" size="small" type="primary" style="margin-left:0.5vw">
              开门场景
            </el-button>
            <el-button v-if="syncScene" @click="upSceneClose" size="small" type="primary" style="margin-left:0.5vw">
              关门场景
            </el-button>
            <el-button @click="addSonArea" size="small" type="primary" style="margin-left:auto">添加子分组</el-button>
            <el-button @click="changName" size="small" type="info" style="margin-left:0.5vw">修改名称</el-button>
            <el-button @click="delArea" size="small" type="danger" style="margin-right:15px">删除分组
            </el-button>
          </div>
          <el-main style="background:#FFFFFF;max-height:80vh">
            <vue2-org-tree
                :data="tab_area"
                :horizontal="true"
                :label-class-name="labelClassName"
                :renderContent="renderContent"
                collapsable
                @on-expand="onExpand"
                @on-node-click="NodeClick">
              <!--              @on-node-mouseover="onMouseover"
                            @on-node-mouseout="onMouseout">-->
            </vue2-org-tree>
            <!-- 创建浮窗盒子 -->
            <div v-show="BasicSwich" class="floating">
              <p>ID:{{ BasicInfo.id }}</p>
              <p>Name:{{ BasicInfo.label }}</p>
            </div>
          </el-main>
        </el-aside>
        <el-container width="40%" style="margin-left:6px;background: #FFFFFF">
          <el-header style="display:flex;height:50px;width:100%;line-height:0.3;text-align:left;
                     align-items: center;background: #FFFFFF">
            <p style="width:100px;font-size:18px;font-weight:bold;margin-left:15px">组内设备</p>
            <el-button @click="add_dev" size="small" type="primary" style="margin-left:auto;margin-right:15px">
              更新设备
            </el-button>
            <!--            <el-button size="small" type="primary" style="margin-right:0">移动设备</el-button>-->
          </el-header>
          <el-main style="background: #FFFFFF;padding-left:15px;padding-right:15px">
            <el-table :data=tableData class="tab_glArea" :cell-style="tableYs1"
                      style="width:100%; font-size:13px; background:#F4F4F4;"
                      :max-height=maxHeight show-overflow-tooltip :row-key="rowKey1"
                      :header-cell-style="{'text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
              <!--              <el-table-column-->
              <!--                type="selection"-->
              <!--                :reserve-selection="true"-->
              <!--                width="60">-->
              <!--              </el-table-column>-->
              <el-table-column v-for="(d,item) in this.defHead" :key=item
                               :prop=d.val :label=d.key :width="d.w">
              </el-table-column>
              <el-table-column
                  label="操作"
                  width="200">
                <template slot-scope="scope">
                  <el-button @click="change_show(scope.row)" type="text" size="small" icon="el-icon-edit"
                             style="color:#72767b;font-size: 16px"/>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
                style="float:right; margin-right:0.5vw;margin-top:5px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange1"
                :current-page="page"
                :page-sizes="[10, 20, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
    <el-dialog title='添加分组设备' center :close-on-click-modal="false"
               width="500px" height="600px" class="dialog_daiAddDev"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiAddDev'> <!--v-draggable 拖动-->
      <div style="display:flex;height:50px;width:100%;line-height:0.3;text-align:left;align-items: center;">
        <el-input v-model="scan_name" prefix-icon="el-icon-search" placeholder="请输入设备名称"
                  style="width:50%;margin-left:0" clearable></el-input>
        <el-input v-model="scan_mac" prefix-icon="el-icon-search" placeholder="请输入设备Did"
                  style="width:50%;margin-left:15px" clearable></el-input>
      </div>
      <div style="margin-top:1px;">
        <el-table :data=fil_tabData class="myTable_db" :cell-style="tableYs" border
                  style="width:100%; font-size:14px; background:#ffffff;"
                  height="40vh" show-overflow-tooltip :row-key="rowKey"
                  @selection-change="handleCurrentChange" ref="multipleTable"
                  :header-cell-style="{'text-align':'left','background':'#F4F4F4','color':'#000000'}">
          <el-table-column
              type="selection"
              :reserve-selection="true"
              :selectable="selectable"
              width="60">
          </el-table-column>
          <el-table-column v-for="(d,item) in this.liDevHead" :key=item
                           :prop=d.val :label=d.key>
          </el-table-column>
        </el-table>
        <div style="display:flex;">
          <!--          <h5>总数：{{ sum_tab }}</h5>-->
          <h5 style="margin-left:0px">选中数：{{ xz_tab }}</h5>
        </div>
      </div>
      <div style="margin-top:10px;display:flex;height:50px;width:100%;line-height:0.3;
                  text-align:left;align-items:center;">
        <el-button @click="dialog_Onclick('退出')" style="margin-left: auto">取消</el-button>
        <el-button @click="dialog_Onclick('保存')" type="primary">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :title=title :visible.sync="daiAddArea" width="300px" style="font-weight:bold;">
      <div style="display:flex;height:50px;width:300px;line-height:0.3;text-align:left;align-items: center;">
        <el-input v-model="edi_areaName" prefix-icon="el-icon-search" placeholder="请输入名称"
                  style="width:260px;"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="daiAddArea = false">取 消</el-button>
        <el-button type="primary" @click="add_area">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="同步场景" :visible.sync="daiScene" width="300px" style="font-weight:bold;">
      <div style="display:flex;height:50px;width:300px;line-height:0.3;text-align:left;align-items: center;">
        <el-input v-model="edi_sceneName" prefix-icon="el-icon-search" placeholder="请输入场景名称"
                  style="width:260px;"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="daiScene = false">取 消</el-button>
        <el-button type="primary" @click="up_scene">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="开门场景" :visible.sync="daiSceneOpen" width="300px" style="font-weight:bold;">
      <p style="margin-top:0">说明：选择为空时保存移除场景</p>
      <div style="display:flex;height:50px;width:300px;line-height:0.3;text-align:left;align-items: center;">
        <el-select v-model="edi_sceneOpen" ref='select4' @click.native="onSelectscene"
                   clearable filterable placeholder="请选择场景"
                   style="width:260px;">
          <el-option
              v-for="item in li_scene"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="daiSceneOpen = false">取 消</el-button>
        <el-button type="primary" @click="up_sceneOpen">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="关门场景" :visible.sync="daiSceneClose" width="300px" style="font-weight:bold;">
      <p style="margin-top:0">说明：选择为空时保存移除场景</p>
      <div style="display:flex;height:50px;width:300px;line-height:0.3;text-align:left;align-items: center;">
        <el-select v-model="edi_sceneClose" ref='select4' @click.native="onSelectscene"
                   clearable filterable placeholder="请选择场景"
                   style="width:260px;">
          <el-option
              v-for="item in li_scene"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="daiSceneClose = false">取 消</el-button>
        <el-button type="primary" @click="up_sceneClose">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="易控导入" :visible.sync="daiYk" width="360px" style="font-weight:bold;"
               contenteditable="true">
      <div style="display:flex;height:36px;width:100%;text-align:left;align-items: center;margin-top:0">
        <p style="width:70px;text-align: left;margin: 0;">选中楼栋：</p>
        <p style="margin: 0;">{{ this.xz_build_name }}，</p>
        <p style="margin: 0;">{{ this.xz_build_id }}</p>
      </div>
      <div style="display:flex;height:36px;width:100%;text-align:left;align-items: center;">
        <p style="width:70px;text-align: left;margin: 0;">选中楼层：</p>
        <p style="margin: 0;">{{ this.xz_floor_name }}，</p>
        <p style="margin: 0;">{{ this.xz_floor_id }}</p>
      </div>
      <p style="width:200px;text-align:left;margin-top: 5px;margin-bottom: 0">项目信息：{{ projectName }}</p>
      <p style="margin: 0">{{ projectId }}</p>
      <p style="width:90px;text-align:left;margin-top:10px;margin-bottom: 0">导入URL：</p>
      <p style="margin: 0;">{{ yk_url }}</p>
      <div style="width:100%;margin-top:10px;display: flex;justify-content: center">
        <el-image
            style="width: 200px; height: 200px"
            :src="yk_urls"
            fit="fit"></el-image>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="daiYk = false">返 回</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑设备信息" :visible.sync="daiShow" width="300px" style="font-weight:bold;">
      <div style="display:flex;height:50px;width:300px;line-height:0.3;text-align:left;align-items: center;">
        控制页面显示设备：
        <el-select v-model="edi_show" ref='select2'
                   @visible-change='show_change2'
                   filterable placeholder="显示状态"
                   style="width:6vw;">
          <el-option
              v-for="item in li_show"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="daiShow = false">取 消</el-button>
        <el-button type="primary" @click="change_dev">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="删除提示"
        :visible.sync="daiDelArea"
        width="30%">
      <span>确定删除该{{ title }}吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiDelArea = false">取 消</el-button>
        <el-button type="primary" @click=del_area()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import 'vue2-org-tree/dist/style.css';
import {auto} from "html-webpack-plugin/lib/chunksorter";
import QRCode from 'qrcode';
/*npm i vue2-org-tree 然后在main.js初始化
 * 报错安装 npm install --save-dev less less-loader*/
export default {
  name:"glArea",
  data() {
    return {
      daiDelArea:false,
      scan_mac:"",
      scan_name:"",
      daiShow:false,
      daiAddArea:false,
      daiScene:false,
      daiSceneOpen:false,
      daiSceneClose:false,
      daiAddDev:false,
      dailog_qxbg:"#283A4D",
      dailog_qdbg:"#283A4D",
      edi_scene:"",
      edi_sceneOpen:"",
      edi_sceneClose:"",
      li_scene:[],
      edi_areaName:"",
      edi_sceneName:"",
      h_text:"区域管理",
      yk_urls:"",
      daiYk:false,
      pageScene:1,
      pageSizeScene:30,
      totalScene:30,
      projectId:localStorage.getItem("projectId"),
      projectName:localStorage.getItem("projectName"),
      li_h_text:[
        {"text":"区域管理","colour":"#B7B7B7","pages":""}
      ],
      maxHeight:window.innerHeight - 175,
      currentIndex:0,
      liDevHead:[
        {'key':"设备名称",'val':"devName","w":"auto"},
        {'key':"Did",'val':"did","w":"auto"}
      ],
      tabData:[],
      defHead:[
        {'key':"设备名称",'val':"dev_name","w":"auto"},
        {'key':"Did",'val':"dev_mac","w":"auto"},
        {'key':"显示状态",'val':"dev_show","w":"auto"}
      ],
      li_dev_xz:[],
      tableData:[
        {'name':"1111",'dev_mac':"item","dev_status":"auto"}
      ],
      BasicSwich:false,
      BasicInfo:{id:null,label:null},
      labelClassName:"tree_bj",
      item:0,
      title:"",
      is_upUid:true,
      build_name:"",
      page:1,
      pageSize:10,
      total:0,
      pageSon:1,
      pageSonSize:30,
      totalSon:30,
      xz_build_id:0,
      xz_build_name:0,
      xz_floor_id:0,
      xz_floor_name:0,
      li_build:[], /*楼栋列表*/
      li_floor:[], /*楼层列表*/
      tab_area:{
        type:"build",
        id:0,
        label:"XXX科技有限公司",
        children:[
          {
            id:2,
            type:"floor",
            build_id:0,
            label:"产品研发部",
            children:[
              {
                id:5,
                type:"room",
                floor_id:2,
                build_id:0,
                label:"研发-前端"
              }
            ]
          }
        ]
      },
      dev_pid:"",
      dev_mac:"",
      edi_show:true,
      li_show:[
        {
          value:true,
          label:'显示'
        },
        {
          value:false,
          label:'隐藏'
        }
      ],
      build_id:"",
      floor_id:"",
      room_id:"",
      syncYk:false,
      syncScene:false,
      li_state:[
        {
          value:1,
          label:'在线'
        },
        {
          value:2,
          label:'离线'
        },
        {
          value:3,
          label:'故障'
        }
      ],
      currentRow:[]
    };
  },
  methods:{  /*方法存放*/
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.get_dev();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.get_dev();
    },
    onSelectscene() {
      console.log("点击下拉框触发");
      // this.li_scene = [];
      // this.pageScene = 1;
      // this.pageSizeScene = 30;
      // this.totalScene = 30;
      // this.getScene();
    },
    upSceneList() {
      this.edi_sceneOpen = 0;
      this.edi_sceneClose = 0;
      this.li_scene = [];
      this.pageScene = 1;
      this.pageSizeScene = 30;
      this.totalScene = 30;
      this.getScene();
    },
    getScene() {
      if (this.pageScene <= this.totalScene / this.pageSizeScene + 1) {
        const params = {
          'page':this.pageScene,
          'all':true,
          'roomId':this.u_id,
          'pageSize':this.pageSizeScene,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.getSceneList,params,headers).then(res => {
          console.log("所有场景",res.data.data);
          this.totalScene = res.data.data["total"];
          let l_d = [];
          if (this.isScene) {
            l_d = this.li_scene;
          }
          let li_d = res.data.data["list"];
          for (let i = 0; i < li_d.length; i++) {
            let d = {
              value:li_d[i]['id'],
              label:li_d[i]['name']
            };
            d['roomName'] = "";
            d['floorName'] = "";
            d['buildName'] = "";
            if (li_d[i]['room']) {
              d['roomName'] = li_d[i]['room']['name'];
              d['floorId'] = li_d[i]['room']['floorId'];
              if (li_d[i]['room']['floor']) {
                d['floorName'] = li_d[i]['room']['floor']['name'];
                d['buildId'] = li_d[i]['room']['floor']['buildingId'];
                if (li_d[i]['room']['floor']['building']) {
                  d['buildName'] = li_d[i]['room']['floor']['building']['name'];
                }
              }
            }
            d["label"] = li_d[i]['name'] + ` (${d['buildName']}/${d['floorName']}/${d['roomName']})`;
            l_d.push(d);
          }
          this.li_scene = l_d;
          this.isScene = true;
          this.pageScene += 1;
          this.getScene();
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("获取触发条件失败");
          }
        });
      }
    },
    selectable(row,index) { /*表格勾选框判断*/
      console.log(row);
      let is_show = true;
      if (row.isBleDev !== false) {
        is_show = false;
      } else if (row.did === "dmy_air_lan_zjl_100") {
        is_show = false;
      }
      return is_show;
    },
    change_show(row) {
      this.dev_mac = row.dev_mac;
      this.dev_pid = row.dev_pid;
      this.edi_show = row.isShow;
      this.daiShow = true;
      console.log(this.dev_mac,this.dev_pid,this.edi_show);
    },
    change_dev() {
      const params = {
        "deviceInfo":[
          {
            "pid":this.dev_pid,
            "did":this.dev_mac,
            "isShow":this.edi_show
          }
        ],
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.showOrHideDevice,params,headers).then(res => {
        console.log(res.data.data);
        this.daiShow = false;
        this.$message.success("修改成功");
        this.getBuilding();
      }).catch(error => {
        console.log(error);
        this.daiShow = false;
        if (error) {
          this.$message.error("修改显示状态失败");
        }
      });
    },
    renderContent(h,data) {
      if (data.id === this.build_id || data.id === this.floor_id || data.id === this.room_id) {
        return h('div',{
          class:'tree_bj1'  // 添加类名也可以使用:label-class-name进行添加
        },[
          h('span',data.label)  // h('br'),h('span', '已完成'),
        ]);
      } else {
        return h('div',[
          h('span',data.label)
        ]);
      }
    },
    show_change2(item) {
      if (item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    handleCurrentChange(val) { /*获取所有选中行*/
      this.currentRow = val;
      console.log(this.currentRow);
    },
    changBuildName() {  /*修改楼栋名称*/
      this.u_id = this.tab_area["u_id"];
      this.edi_areaName = this.tab_area["label"];
      this.title = "修改楼栋名称";
      this.daiAddArea = true;
    },
    del_area() {
      if (this.title === "楼栋") {
        const params = {
          "id":this.u_id,
          "projectId":localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        this.$api.post(this.$urls.ip + this.$urls.delBuilding,params,headers).then(res => {
          console.log(res.data.data);
          this.is_upUid = true;
          this.item -= 1;
          this.currentIndex -= 1;
          this.getBuilding();
          this.daiDelArea = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("删除楼栋失败");
          }
        });
      } else if (this.title === "楼层") {
        const params = {
          "id":this.u_id,
          "projectId":localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.delFloor,params,headers).then(res => {
          console.log(res.data.data);
          this.is_upUid = true;
          this.getBuilding();
          this.daiDelArea = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("删除楼层失败");
          }
        });
      } else if (this.title === "房间") {
        const params = {
          "id":this.u_id,
          "projectId":localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.delRoom,params,headers).then(res => {
          console.log(res.data.data);
          this.is_upUid = true;
          this.getBuilding();
          this.daiDelArea = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("删除房间失败");
          }
        });
      }
    },
    delArea() { /*删除区域*/
      if (this.room_id !== -1) { /*房间id=楼层id*1000+k*/
        this.title = "房间";
        this.u_id = this.tab_area["children"][this.floor_id - 1]["children"][this.room_id - 1000 * this.floor_id]["u_id"];
        this.edi_areaName = this.tab_area["children"][this.floor_id - 1]["children"][this.room_id - 1000 * this.floor_id]["label"];
      } else if (this.floor_id !== -1) {
        this.title = "楼层";
        this.u_id = this.tab_area["children"][this.floor_id - 1]["u_id"];
        this.edi_areaName = this.tab_area["children"][this.floor_id - 1]["label"];
      } else {
        this.title = "楼栋";
        this.u_id = this.tab_area["u_id"];
        this.edi_areaName = this.tab_area["label"];
      }
      this.daiDelArea = true;
    },
    upYk() { /*易控导入*/
      this.up_img(this.yk_url);
      this.daiYk = true;
    },
    upScene() { /*同步场景*/
      this.u_id = this.tab_area["children"][this.floor_id - 1]["children"][this.room_id - 1000 * this.floor_id]["u_id"];
      this.edi_sceneName = this.tab_area["children"][this.floor_id - 1]["children"][this.room_id - 1000 * this.floor_id]["label"];
      this.daiScene = true;
    },
    upSceneOpen() { /*同步开/关门场景*/
      this.u_id = this.tab_area["children"][this.floor_id - 1]["children"][this.room_id - 1000 * this.floor_id]["u_id"];
      this.upSceneList();
      this.getRoomInfo();
      this.daiSceneOpen = true;
    },
    upSceneClose() { /*同步开/关门场景*/
      this.u_id = this.tab_area["children"][this.floor_id - 1]["children"][this.room_id - 1000 * this.floor_id]["u_id"];
      this.upSceneList();
      this.getRoomInfo();
      this.daiSceneClose = true;
    },
    getRoomInfo() {
      const params = {
        "id":this.u_id,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getRoomInfo,params,headers).then(res => {
        console.log("获取房间信息",res.data.data);
        if (res.data.data.openSceneId) {
          this.edi_sceneOpen = res.data.data.openSceneId;
        } else {
          this.edi_sceneOpen = "";
        }
        if (res.data.data.closeSceneId) {
          this.edi_sceneClose = res.data.data.closeSceneId;
        } else {
          this.edi_sceneClose = "";
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取房间信息失败");
        }
      });
    },
    changName() { /*修改名称*/
      if (this.room_id !== -1) { /*房间id=楼层id*1000+k*/
        this.title = "修改房间名称";
        this.u_id = this.tab_area["children"][this.floor_id - 1]["children"][this.room_id - 1000 * this.floor_id]["u_id"];
        this.edi_areaName = this.tab_area["children"][this.floor_id - 1]["children"][this.room_id - 1000 * this.floor_id]["label"];
      } else if (this.floor_id !== -1) {
        this.title = "修改楼层名称";
        this.u_id = this.tab_area["children"][this.floor_id - 1]["u_id"];
        this.edi_areaName = this.tab_area["children"][this.floor_id - 1]["label"];
      } else {
        this.title = "修改楼栋名称";
        this.u_id = this.tab_area["u_id"];
        this.edi_areaName = this.tab_area["label"];
      }
      this.daiAddArea = true;
    },
    addSonArea() { /*添加子分组*/
      if (this.room_id !== -1) { /*房间id=楼层id*1000+k*/
        this.title = "添加房间";
        this.edi_areaName = "";
        this.u_id = this.tab_area["children"][this.floor_id - 1]["u_id"];
      } else if (this.floor_id !== -1) {
        this.title = "添加房间";
        this.edi_areaName = "";
        this.u_id = this.tab_area["children"][this.floor_id - 1]["u_id"];
      } else {
        this.title = "添加楼层";
        this.edi_areaName = "";
        this.u_id = this.tab_area["u_id"];
      }
      this.daiAddArea = true;
    },
    addArea() {
      this.title = "添加区域";
      this.daiAddArea = true;
    },
    up_scene() { /*同步房间场景*/
      const params = {
        "roomId":this.u_id,
        "roomName":this.edi_sceneName,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.syncRoomScene,params,headers).then(res => {
        console.log("同步房间场景",res.data.data);
        this.$message.success("同步场景成功");
        this.daiScene = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("同步场景失败");
        }
      });
    },
    up_sceneOpen() { /*同步房间场景*/
      let ulr = this.$urls.setRoomOpenScene;
      const params = {
        "roomId":this.u_id,
        "projectId":localStorage.getItem("projectId")
      };
      if (this.edi_sceneOpen) {
        ulr = this.$urls.setRoomOpenScene;
        params["openSceneId"] = this.edi_sceneOpen;
      } else {
        ulr = this.$urls.removeRoomOpenScene;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log("开门场景",params);
      this.$api.post(this.$urls.ip + ulr,params,headers).then(res => {
        console.log("同步开门场景",res.data.data);
        this.$message.success("同步开门场景成功");
        this.daiSceneOpen = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("同步场景失败");
        }
      });
    },
    up_sceneClose() { /*同步房间场景*/
      let ulr = this.$urls.setRoomCloseScene;
      const params = {
        "roomId":this.u_id,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      if (this.edi_sceneClose) {
        ulr = this.$urls.setRoomCloseScene;
        params["closeSceneId"] = this.edi_sceneClose;
      } else {
        ulr = this.$urls.removeRoomCloseScene;
      }
      console.log("关门场景",params);
      this.$api.post(this.$urls.ip + ulr,params,headers).then(res => {
        console.log("同步关门场景",res.data.data);
        this.$message.success("同步关门场景成功");
        this.daiSceneClose = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("同步场景失败");
        }
      });
    },
    add_area() { /*添加区域*/
      if (this.title === "添加区域") {
        const params = {
          "name":this.edi_areaName,
          "projectId":localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        this.$api.post(this.$urls.ip + this.$urls.addBuilding,params,headers).then(res => {
          console.log(res.data.data);
          this.getBuilding();
          this.daiAddArea = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("添加楼栋失败");
          }
        });
      } else if (this.title === "添加楼层") {
        const params = {
          "buildingId":this.u_id,
          "name":this.edi_areaName,
          "projectId":localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        this.$api.post(this.$urls.ip + this.$urls.addFloor,params,headers).then(res => {
          console.log(res.data.data);
          this.getBuilding();
          this.daiAddArea = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("添加楼层失败");
          }
        });
      } else if (this.title === "添加房间") {
        const params = {
          "FloorId":this.u_id,
          "name":this.edi_areaName,
          "projectId":localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        this.$api.post(this.$urls.ip + this.$urls.addRoom,params,headers).then(res => {
          console.log(res.data.data);
          this.getBuilding();
          this.daiAddArea = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("添加房间失败");
          }
        });
      } else if (this.title === "修改楼栋名称") {
        const params = {
          "id":this.u_id,
          "name":this.edi_areaName,
          "projectId":localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.updateBuilding,params,headers).then(res => {
          console.log(res.data.data);
          this.getBuilding();
          this.daiAddArea = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("修改楼栋名称失败");
          }
        });
      } else if (this.title === "修改楼层名称") {
        const params = {
          "id":this.u_id,
          "name":this.edi_areaName,
          "projectId":localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.updateFloor,params,headers).then(res => {
          console.log(res.data.data);
          this.getBuilding();
          this.daiAddArea = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("修改楼层名称失败");
          }
        });
      } else if (this.title === "修改房间名称") {
        const params = {
          "id":this.u_id,
          "name":this.edi_areaName,
          "projectId":localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.updateRoom,params,headers).then(res => {
          console.log(res.data.data);
          this.getBuilding();
          this.daiAddArea = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("修改房间名称失败");
          }
        });
      }
    },
    dialog_Onclick(v) {
      switch (v) {
        case "保存":
          const params = {
            "id":this.u_id,
            "devices":[],
            "projectId":localStorage.getItem("projectId")
          };
          for (let i = 0; i < this.currentRow.length; i++) {
            // console.log(this.currentRow[i])
            const d = {
              "did":this.currentRow[i]['did'],
              "pid":this.currentRow[i]['pid'],
              "projectId":localStorage.getItem("projectId")
            };
            params["devices"].push(d);
          }
          console.log(params);
          if (this.title === "楼层") {
            this.up_floor_dev(params);
          } else if (this.title === "房间") {
            this.up_room_dev(params);
          }
          break;
        case "退出":
          clearTimeout(this.timer_wd);  //按钮高亮3毫秒变回
          this.timer_wd = setTimeout(() => {
            this.dailog_qxbg = '#283A4D';
          },300);
          this.daiAddDev = false; /*将dialog关闭*/
          break;
      }
    },
    up_floor_dev(params) { /*楼层*/
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.updateFloorDevice,params,headers).then(res => {
        console.log(res.data.data);
        this.get_dev("floor",params["id"]);
        this.daiAddDev = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改房间名称失败");
        }
      });
    },
    up_room_dev(params) { /*房间*/
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.updateRoomDevice,params,headers).then(res => {
        console.log(res.data.data);
        this.get_dev("room",params["id"]);
        this.daiAddDev = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改房间名称失败");
        }
      });
    },
    btnClick(index) { /*切换区域*/
      this.currentIndex = index;
      this.item = index;
      this.is_upUid = true;
      this.getFloor();
    },
    NodeClick(e,data) { /*树状图点击*/
      // console.log(e) // e 为 event
      console.log(data); // 当前项的所有详情 如：id label children
      let upTab = false;
      if (data.type === "build") {
        this.build_id = data.id;
        this.floor_id = -1;
        this.room_id = -1;
        this.syncYk = false;
        this.syncScene = false;
      } else if (data.type === "floor") {
        this.build_id = data.build_id;
        this.floor_id = data.id;
        this.room_id = -1;
        upTab = true;
        this.page = 1;
        this.syncScene = false;
        this.syncYk = localStorage.getItem("isBle") === "1"; /*"u_id"*/
        this.xz_build_id = this.tab_area["u_id"];
        this.xz_build_name = this.tab_area["label"];
        this.xz_floor_id = data.u_id;
        this.xz_floor_name = data.label;
        this.get_dev("floor",data.u_id);
      } else {
        this.build_id = data.build_id;
        this.floor_id = data.floor_id;
        this.room_id = data.id;
        this.syncYk = false;
        this.syncScene = data.syncScene;
        upTab = true;
        this.page = 1;
        this.get_dev("room",data.u_id);
      }
    },
    onMouseout(e,data) { /*树状图移除*/
      this.BasicSwich = false;
    },
    onMouseover(e,data) { /*树状图移入*/
      this.BasicInfo = data;
      this.BasicSwich = true;
      var floating = document.getElementsByClassName('floating')[0];
      floating.style.left = e.clientX + 'px';
      floating.style.top = e.clientY + 'px';
    },
    collapse(list) { /*折叠效果*/
      var _this = this;
      list.forEach(function (child) {
        if (child.expand) {
          child.expand = false;
        }
        child.children && _this.collapse(child.children);
      });
    },
    onExpand(e,data) { /*展开视图*/
      if ("expand" in data) {
        data.expand = !data.expand;
        if (!data.expand && data.children) {
          this.collapse(data.children);
        }
      } else {
        this.$set(data,"expand",true);
      }
    },
    toggleExpand(data,val) { /*默认展开*/
      var _this = this;
      if (Array.isArray(data)) {
        data.forEach(function (item) {
          _this.$set(item,"expand",val);
          if (item.children) {
            _this.toggleExpand(item.children,val);
          }
        });
      } else {
        this.$set(data,"expand",val);
        if (data.children) {
          _this.toggleExpand(data.children,val);
        }
      }
    },
    rowKey(row) {
      return row.id;
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:left;background:#FFFFFF;color:#000000';
    },
    rowKey1(row) {
      return row.id;
    },
    tableYs1({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#000000';
    },
    initView(data) {
      let syncScene = false;
      if (data["project"]) { /*是否同步场景*/
        syncScene = data["project"]["syncScene"];
      }
      this.syncScene = syncScene;
      if (this.is_upUid) {
        this.build_id = -1;
        this.floor_id = -1;
        this.room_id = -1;
      }
      let d = {
        id:0,
        u_id:this.li_build[this.item]['id'],
        label:this.li_build[this.item]['name'],
        type:"build",
        children:[]
      };
      this.build_name = this.li_build[this.item]['name'];
      // console.log("楼层数据：", this.li_build[this.item])
      for (let j = 0; j < this.li_floor.length; j++) {
        let d1 = {
          id:1 + j, /*楼栋id默认0，楼层id从1开始递增1*/
          build_id:d.id,
          u_id:this.li_floor[j]['id'],
          label:this.li_floor[j]['name'],
          devs:this.li_floor[j]['devices'],
          type:"floor",
          children:[]
        };
        for (let k = 0; k < this.li_floor[j]['rooms'].length; k++) {
          let d2 = {
            id:d1.id * 1000 + k, /*房间id=楼层id*1000+k*/
            build_id:d.id,
            floor_id:d1.id,
            u_id:this.li_floor[j]['rooms'][k]['id'],
            label:this.li_floor[j]['rooms'][k]['name'],
            devs:this.li_floor[j]['rooms'][k]['devices'],
            syncScene:syncScene,
            type:"room"
          };
          if (this.is_upUid) {
            this.room_id = 1000;
          }
          d1.children.push(d2);
        }
        if (this.is_upUid) {
          this.floor_id = 1;
        }
        d.children.push(d1);
      }
      if (this.is_upUid) {
        this.build_id = 0;
      }
      this.tab_area = d;
      this.toggleExpand(this.tab_area,true);
      this.is_upUid = false;
      let devs = [];
      let upTab = false;
      console.log("id访问",this.room_id,this.floor_id);
      if (this.room_id !== -1) { /*房间id=楼层id*1000+k*/
        devs = this.tab_area["children"][this.floor_id - 1]["children"][this.room_id - 1000 * this.floor_id]["devs"];
        upTab = true;
        this.get_dev("room",this.tab_area["children"][this.floor_id - 1]["children"][this.room_id - 1000 * this.floor_id]["u_id"]); /*初始设备*/
      } else if (this.floor_id !== -1) {
        devs = this.tab_area["children"][this.floor_id - 1]["devs"];
        upTab = true;
        this.get_dev("floor",this.tab_area["children"][this.floor_id - 1]["u_id"]); /*初始设备*/
      } else {
        this.li_dev_xz = [];
        this.tableData = [];
      }
    },
    get_dev(name = null,id = null) {
      console.log(name,id);
      if (id === null) {
        id = this.id;
        name = this.name;
      } else {
        this.id = id;
        this.name = name;
      }
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if (name === "floor") {
        params["floorId"] = id;
      } else if (name === "room") {
        params["roomId"] = id;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getDeviceList,params,headers).then(res => {
        console.log("获取设备列表",res.data.data);
        this.total = res.data.data["total"];
        let data = res.data.data["list"];
        this.initDev(true,data);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备信息失败");
        }
      });
    },
    initDev(upTab,ld) { /*初始化表格中设备*/
      if (upTab) {
        let l = [];
        let l_xz = [];
        for (let i = 0; i < ld.length; i++) {
          const d = {
            dev_name:ld[i]['name'],
            dev_pid:ld[i]['pid'],
            dev_mac:ld[i]['did'],
            statusId:ld[i]['statusId'],
            isShow:ld[i]['isShow']
          };
          if (d.isShow) {
            d["dev_show"] = "显示";
          } else {
            d["dev_show"] = "隐藏";
          }
          if (!d["stateId"]) {
            d["stateId"] = 2;
            d["dev_state"] = "离线";
          } else {
            const state = this.li_state.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
              return fruit['value'] === d.stateId;
            });
            if (state !== undefined) {
              d["dev_state"] = state["label"];
            }
          }
          l.push(d);
          l_xz.push(ld[i]['did']);
        }
        this.li_dev_xz = l_xz;
        this.tableData = l;
      } else {
        this.li_dev_xz = [];
        this.tableData = [];
      }
    },
    add_dev() { /*区域关联设备*/
      if (this.room_id !== -1) { /*房间id=楼层id*1000+k*/
        this.title = "房间";
        this.u_id = this.tab_area["children"][this.floor_id - 1]["children"][this.room_id - 1000 * this.floor_id]["u_id"];
        this.daiAddDev = true;
      } else if (this.floor_id !== -1) {
        this.title = "楼层";
        this.u_id = this.tab_area["children"][this.floor_id - 1]["u_id"];
        this.daiAddDev = true;
      } else {
        this.title = "楼栋";
        this.u_id = this.tab_area["u_id"];
        this.$message.error('只支持楼层/房间添加设备');
      }
      this.getDev(); /*添加设备*/
    },
    selectAllRows() { /*设置表格初始默认选中*/
      this.fil_tabData.forEach(row => {
        if (this.li_dev_xz.includes(row.did)) {
          this.$refs.multipleTable.toggleRowSelection(row,true);
        } else {
          this.$refs.multipleTable.toggleRowSelection(row,false);
        }
      });
    },
    getDev() { /*添加设备获取信息*/
      if (this.pageSon <= this.totalSon / this.pageSonSize + 1) {
        const params = {
          'page':this.pageSon,
          'pageSize':this.pageSonSize,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        this.$api.post(this.$urls.ip + this.$urls.getDeviceList,params,headers).then(res => {
          console.log(res.data.data);
          this.totalSon = res.data.data.total;
          let data = res.data.data["list"];
          let l_d = this.tabData;
          for (let i = 0; i < data.length; i++) {
            let d = {
              id:data[i]['did'],
              did:data[i]['did'],
              pid:data[i]['pid'],
              name:data[i]['name'],
              devName:data[i]['name'],
              isBleDev:data[i]["isBleDev"]
            };
            l_d.push(d);
          }
          this.tabData = l_d;
          this.pageSon += 1;
          this.getDev();
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("获取设备信息失败");
          }
        });
      } else {
        this.$refs.multipleTable.clearSelection(); /*清空选中*/
        this.selectAllRows();
      }
    },
    getBuilding() {
      const params = {
        "page":1,
        "pageSize":1000,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getBuildingList,params,headers).then(res => {
        console.log("获取楼栋",res.data.data);
        this.li_build = res.data.data.list;
        this.getFloor();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取楼栋失败");
        }
      });
    },
    getFloor() {
      const params = {
        "page":1,
        "pageSize":1000,
        "id":this.li_build[this.item]['id'],
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getBuildingInfo,params,headers).then(res => {
        console.log("楼层：",res.data.data);
        this.li_floor = res.data.data["floors"];
        this.initView(res.data.data);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取楼层数据失败");
        }
      });
    },
    up_img(s) {
      QRCode.toDataURL(s,(err,url) => {
        if (err) console.error(err);
        console.log(url); // 输出二维码图片的URL
        this.yk_urls = url;
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.getBuilding();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    yk_url() {
      return `${this.$urls.ip}/${localStorage.getItem("projectId")}/${this.xz_build_id}/${this.xz_floor_id}/blload?sharetype=saas_carpark`;
    },
    fil_tabData() {
      return this.tabData.filter(item => {
        this.state = true;
        if (this.scan_name && !item.name.includes(this.scan_name)) {
          this.state = false;
        }
        if (this.scan_mac && !item.did.includes(this.scan_mac)) {
          this.state = false;
        }
        return this.state;
      });
    },
    sum_tab() {
      return this.tabData.length;
    },
    xz_tab() {
      return this.currentRow.length;
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#glArea {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.div_left {
  background: #F4F4F4;
}

.left_main {
  width: 100%;
  padding: 0;
  margin: 0;
  list-style-type: none;
  overflow-y: auto;
}

.left_footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  text-align: center;
  padding: 10px 0;
  line-height: 0.3;
}

.active {
  font-size: 16px;
  background: #E7F0FF;
  color: #134FC2;
  border-radius: 6px 6px 6px 6px;
}

.active1 {
  font-size: 16px;
  background: #F7F7F7;
  border-radius: 6px 6px 6px 6px;
}

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

.dialog_daiAddDev {
  .el-dialog__title {
    color: #000000;
    font-weight: 900;
  }

  .el-dialog__header {
    color: #000000;
    background: #FFFFFF;
  }

  .el-dialog__body {
    color: #000000;
    background: #FFFFFF;
  }
}

.tree_bj {
  color: #434850;
  height: 100%;
  background-color: #FFFFFF;
}

.tree_bj1 {
  color: #3a8ee6;
  height: 100%;
}

/* 盒子css */
.floating {
  background: #D4E3FC;
  width: 160px;
  height: 100px;
  position: absolute;
  color: #434850;
  padding-top: 15px;
  border-radius: 15px;
  padding-left: 15px;
  box-sizing: border-box;
  left: 0;
  top: 0;
  transition: all 0.3s;
  z-index: 999;
  text-align: left;
  font-size: 12px;
}

.el-divider--horizontal { /*分割线样式*/
  margin: 0px 0% 0% 0%; /*上 右 下 左*/
  width: 100%;
  background: #F2F2F2;
}
</style>



// WEBPACK FOOTER //
// src/pages/gls/glArea.vue